import { type JSX, Match, Switch } from "solid-js";
import { Skeleton } from "@fleet/ui";
import { useVault } from "../vault-context";
import { VaultSetup } from "./vault-setup";
import { VaultUnlock } from "./vault-unlock";

/**
 * Vault gate: displays setup / unlock / content depending on state.
 * Content (`children`) only renders when vault is unlocked,
 * guaranteeing keys are in memory before decrypting anything.
 */
export function VaultGate(props: { children: JSX.Element }) {
  const vault = useVault();
  return (
    <Switch>
      <Match when={vault.status() === "loading"}>
        <div class="mx-auto flex max-w-2xl flex-col gap-3 px-4 py-10">
          <Skeleton class="h-8 w-40" />
          <Skeleton class="h-16 w-full" />
          <Skeleton class="h-16 w-full" />
        </div>
      </Match>
      <Match when={vault.status() === "needs-setup"}>
        <VaultSetup />
      </Match>
      <Match when={vault.status() === "locked"}>
        <VaultUnlock />
      </Match>
      <Match when={vault.status() === "unlocked"}>{props.children}</Match>
    </Switch>
  );
}
